import { useTranslation } from 'react-i18next';
import { StatusBadge, type BadgeTone } from '../StatusBadge';

// Tone fisso per stato. La label viene tradotta via i18n (SP-7g).
// Accetta sia il `display_status` (preferito: unassigned/assigned/...)
// sia il raw DB status (open/in_progress/...).
const TONE_BY_STATUS: Record<string, BadgeTone> = {
  unassigned:  'neutral',
  assigned:    'primary',
  in_progress: 'warn',
  fulfilled:   'success',
  confirmed:   'primary',
  cancelled:   'danger',
  archived:    'neutral',
  open: 'neutral',
};

/**
 * Mapping status → i18n key. `display_status` valori 'unassigned' e 'assigned'
 * vivono nel namespace picklist (sono concetti UI-only del backend); gli altri
 * sono stati FSM canonici e stanno in common:status.
 */
const I18N_KEY_BY_STATUS: Record<string, string> = {
  unassigned:  'picklist:status_display.unassigned',
  assigned:    'picklist:status_display.assigned',
  in_progress: 'common:status.in_progress',
  fulfilled:   'common:status.fulfilled',
  confirmed:   'common:status.confirmed',
  cancelled:   'common:status.cancelled',
  archived:    'common:status.archived',
  open:        'picklist:status_display.unassigned',
};

export interface PickListStatusBadgeProps {
  /**
   * Pass the backend-derived `display_status` when available. The component
   * accepts a raw FSM status as a fallback for callsites that don't surface
   * the derived field yet.
   */
  status: string;
}

// SP-8h — "Ricevuta" (unassigned/open) = blu chiaro, fuori palette tone.
const CLASS_BY_STATUS: Record<string, string> = {
  unassigned: 'vp-tag-ricevuta',
  open: 'vp-tag-ricevuta',
};

export function PickListStatusBadge({ status }: PickListStatusBadgeProps) {
  const { t } = useTranslation(['picklist', 'common']);
  const tone = TONE_BY_STATUS[status] ?? 'neutral';
  const key = I18N_KEY_BY_STATUS[status];
  const label = key ? t(key) : status;
  return <StatusBadge tone={tone} className={CLASS_BY_STATUS[status]}>{label}</StatusBadge>;
}
